<template>
  <div v-if="true" class="message-container">
    <div class="alert" v-for="message in getAllMessages" :class="getMessageClass(message.type)">
      <span>
        {{ message.message }}
      </span>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'global-messages',
  computed: {
    ...mapGetters(['getAllMessages']),
    hasMessages: () => !!this.getAllMessages,
  },
  methods: {
    getMessageClass: function (type) {
      switch (type) {
        case 'success':
          return 'alert-success';
        case 'errors':
          return 'alert-danger';
        case 'info':
          return 'alert-info';
      }
      alert(type)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Messages.vue